import React from 'react';
import lazyGettext from 'js-utils/lazy-gettext';
import {
    CONTACT_US_TEXT,
    CUSTOM_PRICING,
    DEFAULT_PACKAGE_TYPES,
    DEFAULT_PACKAGES,
    FINE_PRINT_WITH_FIXED_FEE,
    GET_STARTED_TEXT,
    PACKAGE_DESCRIPTIONS,
    PACKAGE_ONE,
    PACKAGE_ONE_NAME,
    PACKAGE_ONE_PATH,
    PACKAGE_THREE,
    PACKAGE_THREE_NAME,
    PACKAGE_THREE_PATH,
    PACKAGE_TWO,
    PACKAGE_TWO_NAME,
    PACKAGE_TWO_PATH,
    PER_PAID_TICKET_TEXT,
    PRICE_PER_PAID_TICKET,
} from '../../constants/main';
import {
    PACKAGE_ONE_FEATURES,
    PACKAGE_THREE_FEATURES,
    PACKAGE_TWO_FEATURES_ALL,
} from '../../constants/features';
import {
    CHANGE_PACKAGE,
    FREE_OPTION,
    PACKAGE_DIFFER,
    PAY_FEES,
    PAYMENT_OPTIONS,
    PRIVATE_EVENT,
    TICKET_TYPE,
    TICKETING_ESSENTIALS,
} from '../../constants/faqs';
import {
    BRANDED_PAGES,
    CUSTOMER_SUPPORT,
    CUSTOMIZABLE_CHECKOUT_FORMS,
    DETAIL_SALES_ANALYTICS,
    LISTING_PARTNER_SITES,
    ONSITE_RENTAL_SUPPORT,
    TICKET_SALES_SITE,
    TICKET_TYPES,
    TR_ESSENTIALS,
} from '../../constants/signupFeatures';
import {
    PRICE_PER_FREE_TICKET,
    PRODUCT_TRAINING,
} from '../../constants/featuresComparison';
import {
    STYLE_FILL,
    STYLE_NEUTRAL,
} from 'eventbrite_design_system/button/constants';

import BookRoundIllustrationSvg from 'eventbrite_design_system/iconography/icons/BookRoundIllustration';

export default {
    grid: {
        packages: DEFAULT_PACKAGES,
        packageTypes: DEFAULT_PACKAGE_TYPES,
        primaryHeading: lazyGettext("Find the solution that's right for you"),
        secondaryHeading: lazyGettext(
            'Avoid ticketing fees by passing them to attendees',
        ),
        featureDescriptions: PACKAGE_DESCRIPTIONS,
        feeBreakdownOverride: {
            [PACKAGE_THREE]: {
                formattedFee: lazyGettext('Custom'),
            },
        },
        extraMainFeatures: [
            CUSTOMER_SUPPORT,
            TICKET_TYPES,
            TR_ESSENTIALS,
            LISTING_PARTNER_SITES,
            TICKET_SALES_SITE,
            CUSTOMIZABLE_CHECKOUT_FORMS,
            DETAIL_SALES_ANALYTICS,
            ONSITE_RENTAL_SUPPORT,
            BRANDED_PAGES,
            PRODUCT_TRAINING,
        ],
        CTAs: [GET_STARTED_TEXT, GET_STARTED_TEXT, CONTACT_US_TEXT],
        CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        showFinePrint: false,
        finePrint: lazyGettext(''),
        pricePerPaidTicket: PRICE_PER_PAID_TICKET,
        pricePerFreeTicket: PRICE_PER_FREE_TICKET,
        shouldShowAnnualFee: false,
    },
    packagesList: {
        heading: lazyGettext("Find the solution that's right for you"),
        secondaryHeading: lazyGettext(
            'Avoid ticketing fees by passing them to attendees',
        ),
        packages: {
            [PACKAGE_ONE]: {
                name: PACKAGE_ONE_NAME,
                description: lazyGettext(
                    'The essentials you need to start selling in minutes',
                ),
                priceDescription: lazyGettext('Free for free tickets'),
                features: PACKAGE_ONE_FEATURES,
                secondaryCTA: lazyGettext('Learn about Essentials'),
                packagePath: PACKAGE_ONE_PATH,
                isProminentPackage: false,
                logoBgColor: 'grey-900',
                logoImg: 'pricing/logo-essentials',
                logoWidth: 142,
                logoHeight: 35,
            },
            [PACKAGE_TWO]: {
                name: PACKAGE_TWO_NAME,
                description: lazyGettext(
                    'A powerful solution to boost sales and grow your business',
                ),
                priceDescription: lazyGettext('Free for free tickets'),
                includeOtherFeatures: true,
                features: PACKAGE_TWO_FEATURES_ALL,
                secondaryCTA: lazyGettext('Learn about Professional'),
                packagePath: PACKAGE_TWO_PATH,
                isProminentPackage: true,
                logoBgColor: 'ui-orange',
                logoImg: 'pricing/logo-professional',
                logoWidth: 257,
                logoHeight: 30,
            },
            [PACKAGE_THREE]: {
                name: PACKAGE_THREE_NAME,
                description: lazyGettext(
                    'Tailored partnerships for large and complex events',
                ),
                includeOtherFeatures: true,
                priceDescription: CUSTOM_PRICING,
                features: PACKAGE_THREE_FEATURES,
                secondaryCTA: lazyGettext('Learn about Premium'),
                packagePath: PACKAGE_THREE_PATH,
                isProminentPackage: false,
                logoBgColor: 'white',
                logoImg: 'pricing/logo-premium',
                logoWidth: 155,
                logoHeight: 61,
            },
        },
        CTAs: [
            lazyGettext('Create an Event'),
            lazyGettext('Create an Event'),
            lazyGettext('Contact us'),
        ],
        CTAStyles: [STYLE_NEUTRAL, STYLE_FILL, STYLE_NEUTRAL],
        perPaidTicketText: PER_PAID_TICKET_TEXT,
        finePrint: FINE_PRINT_WITH_FIXED_FEE,
    },
    faqs: {
        heading: lazyGettext('Frequently asked questions'),
        bannerHeading: lazyGettext(
            "Don't see a feature you need? There's a lot more under the hood.",
        ),
        bannerCTA: lazyGettext('Compare all features'),
        illustration: <BookRoundIllustrationSvg />,
        faqs: [
            CHANGE_PACKAGE,
            TICKET_TYPE,
            FREE_OPTION,
            TICKETING_ESSENTIALS,
            PACKAGE_DIFFER,
            PRIVATE_EVENT,
            PAY_FEES,
            PAYMENT_OPTIONS,
        ],
    },
};
